
import React from 'react';
import '../MainPage/MainPage.less'
import './LegalInformation.less'
import { withTranslation } from 'react-i18next';

class LegalInformation extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <div className='main_page legalInformation'>
                <div className='user_files_container'>
                    <div className='user_files_list_header'>
                        <div className='user_files_list_header_left'>
                            <label id='Models'>{t('CorporateInfoTitle')}</label>
                        </div>
                    </div>
                    <div className='user_files_list_container'>
                        <div className='user_files_list'>
                            <h3>{t('CorporateInfoText')}</h3>
                            <br/>
                            <h3>{t('CorporateInfoResponsibilityTitle')}</h3>
                            <br/>
                            <p>{t('CorporateInfoResponsibilityText')}</p>
                            <br/>
                            <h3>{t('CorporateInfoEditorialContentTitle')}</h3>
                            <br/>
                            <p>{t('CorporateInfoEditorialContentText')}</p>
                            <br/>
                            <h3>{t('CorporateInfoResolutionTitle')}</h3>
                            <br/>
                            <p>{t('CorporateInfoResolutionText')}</p>
                        </div>
                    </div>
                </div>
            </div>

        )
    };
}
export default withTranslation()(LegalInformation);
